import styled from 'styled-components';
import { Layout } from 'antd';

export const Container = styled(Layout)`
  min-height: 100%;

  > .ant-layout-content {
    padding: 30px;
  }
`;

export const DrawerButton = styled.button`
  position: fixed;
  right: 20px;
  bottom: 50vh;
  z-index: 3100;
  background-color: #10bacb;
  color: white;
  border: none;
  border-radius: 50%;
  padding: 8px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, background-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background-color: #0ea4b4; /* um tom mais escuro para dar destaque */
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35); /* sombra mais forte */
  }

  ${({ $open }) =>
    $open &&
    `
    transform: translateX(-50vw);
  `}
`;

export const CustomDrawer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 50%;
  background: white;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  transition: transform 0.3s ease;
  z-index: 3000;

  &.open {
    transform: translateX(0);
  }
`;

export const DrawerContent = styled.div`
  padding: 24px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
`;
